import t from '../actions/actionTypes'

const defaultState = {
	selectedTab: '',
	isReferralVisible: false,
	referral: {status: '', value: '', message: ''},
	passwordConditions: null,
	possibleStudent: false,
	isTeacher: null,
	pcode: null,
	obLessonData: {
		obEntityUID: 0,
		obEntityType: '',
	},
}

const shareReducer = (state = defaultState, action) => {
	switch (action.type) {
		case t.SIGNUP_CHANGE_TAB:
		case t.SIGNUP_CHANGE_TAB_STUDENT:
		case t.SIGNUP_CHANGE_TAB_TEACHER:
			return Object.assign({}, state, {
				selectedTab: action.selectedTab,
			})
		case t.SIGNUP_REFERRAL_SUCCESS: {
			const newState = {...state}
			newState.referral = Object.assign({}, state.referral, {
				status: 'success',
				value: action.value,
			})
			return newState
		}
		case t.SIGNUP_REFERRAL_ERROR: {
			const newState = {...state}
			newState.referral = Object.assign({}, state.referral, {
				status: 'error',
				value: '',
				message: action.message,
			})
			return newState
		}
		case t.SIGNUP_REFERRAL_RESET: {
			const newState = {...state}
			newState.referral = Object.assign({}, state.referral, {
				status: '',
				value: '',
				message: '',
			})
			return newState
		}
		case t.SIGNUP_SHOW_REFERRAL_INPUT: {
			const newState = {...state}
			newState.isReferralVisible = true
			return newState
		}
		case t.SIGNUP_INITIALIZE: {
			let newState
			if (action.params.pcode) {
				newState = {...state}
				newState.isReferralVisible = true
				newState.pcode = action.params.pcode
				state = newState
			}
			if (action.params.obUID && action.params.obType) {
				newState = {...state}
				newState.obLessonData = {...state.obLessonData}
				newState.obLessonData.obEntityUID = action.params.obUID
				newState.obLessonData.obEntityType = action.params.obType
				state = newState
			}
			return state
		}
		case t.SIGNUP_SET_PASSWORD_CONDITIONS: {
			const newState = {...state}
			newState.passwordConditions = Object.assign(
				{},
				state.passwordConditions,
				action.conditions
			)
			return newState
		}
		case t.SIGNUP_ASK_IF_STUDENT: {
			const newState = {...state}
			newState.possibleStudent = true
			return newState
		}
		case t.SIGNUP_IS_TEACHER_CONFIRMATION: {
			const newState = {...state}
			newState.possibleStudent = false
			newState.isTeacher = true
			return newState
		}
		default:
			return state
	}
}

export default shareReducer
